var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contest-registration-successful-page" }, [
    _vm.contestName
      ? _c("h1", { staticClass: "contest-name" }, [
          _vm._v(_vm._s(_vm.contestName))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contest-content-wrap" },
      [
        _c("span", { staticClass: "contest-info-name-details--success" }),
        _vm._v(" "),
        _c("div", { staticClass: "contest-registration-info" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Registration.Info.One")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("Contests.Registration.Info.Two"))),
            _c("span", [_vm._v(_vm._s(_vm.contestEntryAlias))])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("Contests.Registration.Info.Three"))),
            _c("span", [_vm._v(_vm._s(_vm.contestName))])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Registration.Info.Four")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contest-registration-start-time" }, [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Contests.Registration.Starts")) +
                " " +
                _vm._s(_vm.startUtcTime)
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contest-registration-transaction" },
          [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$t("Contests.Registration.Transaction.Heading"))
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", [_vm._v("$" + _vm._s(_vm.entryFee))]),
              _vm._v(" " + _vm._s(_vm.$t("Contests.Registration.Fee")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("Contests.Registration.Reference")) + " "),
              _c("span", [_vm._v(_vm._s(_vm.transactionReference))])
            ]),
            _vm._v(" "),
            _vm.entryFeeDiscount
              ? _c("p", [
                  _vm._v(_vm._s(_vm.$t("Contests.Registration.Vaucer")) + " "),
                  _c("span", [_vm._v("$" + _vm._s(_vm.entryFeeDiscount))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "btn--more-info",
                attrs: { to: { name: "account-transactions" } }
              },
              [_vm._v(_vm._s(_vm.$t("Contests.Registration.More")))]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          { staticClass: "btn--done", attrs: { to: { name: "contests" } } },
          [_vm._v(_vm._s(_vm.$t("Contests.Registration.Done")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6802c001", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6802c001","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contests/ContestRegistrationSuccessfulPage.vue
// module id = null
// module chunks = 